const isPlainObject = (value) => Object.prototype.toString.call(value) === '[object Object]';

export const cloneCytoscapeValue = (value) => {
  if (Array.isArray(value)) {
    return value.map((item) => cloneCytoscapeValue(item));
  }

  if (isPlainObject(value)) {
    return Object.entries(value).reduce((accumulator, [key, itemValue]) => {
      accumulator[key] = cloneCytoscapeValue(itemValue);
      return accumulator;
    }, {});
  }

  return value;
};

export const toMutableCytoscapeElements = (elements) => {
  if (!Array.isArray(elements) || elements.length === 0) {
    return [];
  }

  return elements.map((element) => cloneCytoscapeValue(element));
};
